import { GridValueGetterParams } from "@mui/x-data-grid";
import moment from "moment";
import "../guestboard/style.css"
import { WrapText } from "@mui/icons-material";
export const DashboardEntity = [
    {
        key: "WelcomeBoard",
        name: "WelcomeBoard",
        label: "Welcome Board",
        reportName: "WelcomeBoardReport",
        endpoint: "WelcomeBoard",
    },
    {
        key: "GuestStatusBoard",
        name: "GuestStatusBoard",
        label: "Progress Monitor",
        reportName: "GuestStatusBoardReport",
        endpoint: "GuestStatusBoard",
    },
    {
        key: "WorkshopStatusBoard",
        name: "WorkshopStatusBoard",
        label: "Workshop Controller Progress Monitor",
        reportName: "WorkshopStatusBoardReport",
        endpoint: "WorkshopStatusBoard",
    },
];

function getDeliveryTime(params: GridValueGetterParams) {
    return moment(params.row.PromisedDeliveryTime).format("h:mm A");
}
function getStatusOfDeliveryTime(params: GridValueGetterParams) {
   return params.row.GuestRepairStatusName === "Vehicle Ready For Delivery" ? "deliveryTime" : params.row.GuestRepairStatusName === "RO Created & Submitted for Guest approval" ? "deliveryTimeofACA" : "otherDeliveryTime"
}

function getOpenTime(params: GridValueGetterParams) {
    return moment(params.row.DocDate).format("h:mm A");
}


export const GuestStatusBoard = [
    {
        field: "GuestName",
        headerName: "GUEST NAME",
        editable: false,
        flex: 1,
        minWidth: 100,
        headerAlign: "center",
        cellClassName: "rowColor1",
        sortable: false,
        
    },
    {
        field: "RegistrationNo",
        headerName: "REG NO.",
        editable: false,
        flex: 1,
        minWidth: 100,
        cellClassName: "rowColor",
        headerAlign: "center",
        sortable: false,
        align: "left"

    },

    {
        field: "SalesPersonName",
        headerName: " SERVICE ADVISOR",
        editable: false,
        flex: 1,
        minWidth: 100,
        cellClassName: "rowColor",
        sortable: false,
        headerAlign: "center",
        align: "left"


    },
    {
        field: "GuestRepairStatusName",
        headerName: "STATUS",
        editable: false,
        flex: 1,
        minWidth: 100,
        cellClassName: "rowColor",
        align: "left",
        headerAlign: "center",
        sortable: false
        
    },
    {
        field: "DocDate",
        headerName: "RO OPEN TIME",
        editable: false,
        flex: 1,
        minWidth: 100,
        valueGetter: getOpenTime,
        cellClassName: "roOpenTime",
        align: "center",
        headerAlign: "center",
        sortable: false
        

    },
    {
        field: "PromisedDeliveryTime",
        headerName: "PROMISED DELIVERY TIME",
        editable: false,
        flex: 1,
        minWidth: 230,
        valueGetter: getDeliveryTime,
        cellClassName: getStatusOfDeliveryTime, //"deliveryTime",
        align: "center",
        headerAlign: "center",
        sortable: false

    },
];

export const Data = {
    "workshopStartTime": "2022-06-20T09:00:00",
    "workshopEndTime": "2022-06-20T18:00:00",
    "bracket": "60",
    "TechnicianList": [
        {
            "id": 1,
            name: "Anil Singh",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T09:00:00",
                    "scheduleEndDatetime": "2023-06-20T11:00:00",
                    "regNo": "MH14JT6709"
                },
                {
                    "scheduleStartDatetime": "2023-06-20T15:00:00",
                    "scheduleEndDatetime": "2023-06-20T16:00:00",
                    "regNo": "MH14JT0709"
                },
            ]

        },
        {
            "id": 2,
            name: "Anil Singh2",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T07:00:00",
                    "scheduleEndDatetime": "2023-06-20T08:00:00",
                    "regNo": "MH14JT6708"
                },
                {
                    "scheduleStartDatetime": "2023-06-20T15:00:00",
                    "scheduleEndDatetime": "2023-06-20T16:00:00",
                    "regNo": "MH14JT0706"
                },
            ]

        },
        {
            "id": 3,
            name: "Anil Singh3",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T07:00:00",
                    "scheduleEndDatetime": "2023-06-20T08:00:00",
                    "regNo": "MH14JT6708"
                },
                {
                    "scheduleStartDatetime": "2023-06-20T15:00:00",
                    "scheduleEndDatetime": "2023-06-20T16:00:00",
                    "regNo": "MH14JT0706"
                },
            ]

        },
        {
            "id": 4,
            name: "Anil Singh4",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T07:00:00",
                    "scheduleEndDatetime": "2023-06-20T08:00:00",
                    "regNo": "MH14JT6708"
                },
                {
                    "scheduleStartDatetime": "2023-06-20T15:00:00",
                    "scheduleEndDatetime": "2023-06-20T16:00:00",
                    "regNo": "MH14JT0706"
                },
            ]

        },
        {
            "id": 5,
            name: "Anil Singh5",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T07:00:00",
                    "scheduleEndDatetime": "2023-06-20T08:00:00",
                    "regNo": "MH14JT6708"
                },
                {
                    "scheduleStartDatetime": "2023-06-20T15:00:00",
                    "scheduleEndDatetime": "2023-06-20T16:00:00",
                    "regNo": "MH14JT0706"
                },
            ]

        },
        {
            "id": 6,
            name: "Anil Singh6",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T09:00:00",
                    "scheduleEndDatetime": "2023-06-20T11:00:00",
                    "regNo": "MH14JT6709"
                },
            ]

        },
        {
            "id": 7,
            name: "Anil Singh7",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T09:00:00",
                    "scheduleEndDatetime": "2023-06-20T11:00:00",
                    "regNo": "MH14JT6709"
                },
            ]

        },
        {
            "id": 8,
            name: "Anil Singh8",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T09:00:00",
                    "scheduleEndDatetime": "2023-06-20T11:00:00",
                    "regNo": "MH14JT6709"
                },
            ]

        },
        {
            "id": 9,
            name: "Anil Singh9",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T09:00:00",
                    "scheduleEndDatetime": "2023-06-20T11:00:00",
                    "regNo": "MH14JT6709"
                },
            ]

        },
        {
            "id": 10,
            name: "Anil Singh10",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T09:00:00",
                    "scheduleEndDatetime": "2023-06-20T11:00:00",
                    "regNo": "MH14JT6709"
                },
            ]

        },
        {
            "id": 11,
            name: "Anil Singh11",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T09:00:00",
                    "scheduleEndDatetime": "2023-06-20T11:00:00",
                    "regNo": "MH14JT6709"
                },
                {
                    "scheduleStartDatetime": "2023-06-20T15:00:00",
                    "scheduleEndDatetime": "2023-06-20T16:00:00",
                    "regNo": "MH14JT0709"
                },
            ]

        },
        {
            "id": 12,
            name: "Anil Singh12",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T07:00:00",
                    "scheduleEndDatetime": "2023-06-20T08:00:00",
                    "regNo": "MH14JT6708"
                },
                {
                    "scheduleStartDatetime": "2023-06-20T15:00:00",
                    "scheduleEndDatetime": "2023-06-20T16:00:00",
                    "regNo": "MH14JT0706"
                },
            ]

        },
        {
            "id": 13,
            name: "Anil Singh13",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T07:00:00",
                    "scheduleEndDatetime": "2023-06-20T08:00:00",
                    "regNo": "MH14JT6708"
                },
                {
                    "scheduleStartDatetime": "2023-06-20T15:00:00",
                    "scheduleEndDatetime": "2023-06-20T16:00:00",
                    "regNo": "MH14JT0706"
                },
            ]

        },
        {
            "id": 14,
            name: "Anil Singh14",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T07:00:00",
                    "scheduleEndDatetime": "2023-06-20T08:00:00",
                    "regNo": "MH14JT6708"
                },
                {
                    "scheduleStartDatetime": "2023-06-20T15:00:00",
                    "scheduleEndDatetime": "2023-06-20T16:00:00",
                    "regNo": "MH14JT0706"
                },
            ]

        },
        {
            "id": 15,
            name: "Anil Singh15",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T07:00:00",
                    "scheduleEndDatetime": "2023-06-20T08:00:00",
                    "regNo": "MH14JT6708"
                },
                {
                    "scheduleStartDatetime": "2023-06-20T15:00:00",
                    "scheduleEndDatetime": "2023-06-20T16:00:00",
                    "regNo": "MH14JT0706"
                },
            ]

        },
        {
            "id": 16,
            name: "Anil Singh16",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T09:00:00",
                    "scheduleEndDatetime": "2023-06-20T11:00:00",
                    "regNo": "MH14JT6709"
                },
            ]

        },
        {
            "id": 17,
            name: "Anil Singh17",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T09:00:00",
                    "scheduleEndDatetime": "2023-06-20T11:00:00",
                    "regNo": "MH14JT6709"
                },
            ]

        },
        {
            "id": 18,
            name: "Anil Singh18",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T09:00:00",
                    "scheduleEndDatetime": "2023-06-20T11:00:00",
                    "regNo": "MH14JT6709"
                },
            ]

        },
        {
            "id": 19,
            name: "Anil Singh19",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T09:00:00",
                    "scheduleEndDatetime": "2023-06-20T11:00:00",
                    "regNo": "MH14JT6709"
                },
            ]

        },
        {
            "id": 20,
            name: "Anil Singh20",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T09:00:00",
                    "scheduleEndDatetime": "2023-06-20T11:00:00",
                    "regNo": "MH14JT6709"
                },
            ]

        },
        {
            "id": 21,
            name: "Anil Singh21",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T09:00:00",
                    "scheduleEndDatetime": "2023-06-20T11:00:00",
                    "regNo": "MH14JT6709"
                },
                {
                    "scheduleStartDatetime": "2023-06-20T15:00:00",
                    "scheduleEndDatetime": "2023-06-20T16:00:00",
                    "regNo": "MH14JT0709"
                },
            ]

        },
        {
            "id": 22,
            name: "Anil Singh22",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T07:00:00",
                    "scheduleEndDatetime": "2023-06-20T08:00:00",
                    "regNo": "MH14JT6708"
                },
                {
                    "scheduleStartDatetime": "2023-06-20T15:00:00",
                    "scheduleEndDatetime": "2023-06-20T16:00:00",
                    "regNo": "MH14JT0706"
                },
            ]

        },
        {
            "id": 23,
            name: "Anil Singh23",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T07:00:00",
                    "scheduleEndDatetime": "2023-06-20T08:00:00",
                    "regNo": "MH14JT6708"
                },
                {
                    "scheduleStartDatetime": "2023-06-20T15:00:00",
                    "scheduleEndDatetime": "2023-06-20T16:00:00",
                    "regNo": "MH14JT0706"
                },
            ]

        },
        {
            "id": 24,
            name: "Anil Singh24",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T07:00:00",
                    "scheduleEndDatetime": "2023-06-20T08:00:00",
                    "regNo": "MH14JT6708"
                },
                {
                    "scheduleStartDatetime": "2023-06-20T15:00:00",
                    "scheduleEndDatetime": "2023-06-20T16:00:00",
                    "regNo": "MH14JT0706"
                },
            ]

        },
        {
            "id": 25,
            name: "Anil Singh25",
            "Times": [
                {
                    "scheduleStartDatetime": "2023-06-20T07:00:00",
                    "scheduleEndDatetime": "2023-06-20T08:00:00",
                    "regNo": "MH14JT6708"
                },
                {
                    "scheduleStartDatetime": "2023-06-20T15:00:00",
                    "scheduleEndDatetime": "2023-06-20T16:00:00",
                    "regNo": "MH14JT0706"
                },
            ]

        },
      
    ],
    "AllVehicleStatusCount": [
        {
            "Name": "Awaiting Technician Allocation",
            "Count": 2
        },
        {
            "Name": "Quality Inspection Completed",
            "Count": 1
        },
        {
            "Name": "Repair on Hold",
            "Count": 1
        },
        {
            "Name": "RO Confirmation Received from Guest",
            "Count": 3
        },
        {
            "Name": "RO Created",
            "Count": 6
        },
        {
            "Name": "RO Created & Submitted for Guest Approval",
            "Count": 3
        },
        {
            "Name": "Technician Allocated",
            "Count": 12
        },
        {
            "Name": "Vehicle Delivered",
            "Count": 1
        },
        {
            "Name": "Work in Progress",
            "Count": 3
        }
    ],
    "WorkShopStatusDetails": [
        {
            "Name": "Quality Inspection Awaited",
            "ID": 1,
            "RegNo": [
                {
                    "ID": 14,
                    "RegistrationNo": "HR55CA2340"
                },
                {
                    "ID": 26,
                    "RegistrationNo": "HRC12345"
                },
            ]
        },
        {
            "Name": "Washing Awaited",
            "ID": 2,
            "RegNo": [
                {
                    "ID": 30,
                    "RegistrationNo": "EROM1234"
                },
                {
                    "ID": 12,
                    "RegistrationNo": "HR26CA0538"
                },
               
            ]
        },
        {
            "Name": "Vehicle Pending",
            "ID": 4,
            "RegNo": [
                {
                    "ID": 26,
                    "RegistrationNo": "HRC12345"
                },
                {
                    "ID": 22,
                    "RegistrationNo": "TS07BDR1990"
                },
               
            ]
        },
    ]
}


